<!--
 * @Description: 确认支付
 * @Date: 2019-09-02 09:48:51
 -->
<template>
  <div>
    <el-dialog
      :visible="true"
      width="800px"
      class="chartDia"
      :show-close="false"
      @close="close"
    >
      <div slot="title" class="slotTit">
        {{ table.orderStatus | transorderStatus }}
      </div>
      <!-- <div class="payDetail" @click="check('payHistory')">支付详情</div> -->
      <div v-if="table.orderStatus == 1" class="imgBox">
        <img src="@/assets/3.png" />
        <div class="imgLabel">支付中</div>
        <div class="imgDes">
          系统正在对订单进行支付，请耐心等待，终端到账时间为T+1天
        </div>
      </div>
      <div v-else-if="table.orderStatus == 3" class="imgBox">
        <img src="@/assets/2.png" />
        <div class="imgLabel">支付失败</div>
        <div class="imgDes">
          您的账户余额不足，本次支付失败，请重新提交支付
        </div>
      </div>
      <div v-else-if="table.orderStatus == 2" class="imgBox">
        <img src="@/assets/1.png" />
        <div class="imgLabel">支付成功</div>
        、
      </div>
      <div class="flexBox">
        <div class="leftBox">
          <b>订单编号：</b>
          {{ table.orderNo }}
        </div>
        <div>
          <b>企业名称：</b>
          {{ table.enterpriseName }}
        </div>
      </div>
      <div class="flexBox borderBtm">
        <div class="leftBox">
          <b>任务月度：</b>
          {{ table.ChargeDt }}
        </div>
      </div>
      <div class="flexBox borderBtm" style="padding-top:20px;">
        <div class="leftBox">
          <b style="color:#bfbfbf;">杂费：</b>
          {{ table.orderPrice | money }}
        </div>
        <!-- <div>
          到账时间：
          <b>{{ transDt(table.finishPayDt) }}</b>
        </div> -->
      </div>
      <div style="text-align:right;margin-bottom:50px;">
        本次支付金额：
        <b style="color:#1989FA;font-size:30px;">
          {{ table.orderPrice | money }}
        </b>
        <i style="font-size:20px;font-style:normal">元</i>
      </div>
      <div
        class="flexBox"
        v-if="table.orderStatus == 0"
        style="justify-content:space-between;"
      >
        <div style="display:flex;">
          <b class="colorBf" style="margin-right:40px;line-height:40px;">
            支付通道：
          </b>
          <el-select v-model="key" class="accountType">
            <el-option value="baofu" label="众邦银行"></el-option>
          </el-select>
        </div>
        <div>
          可用余额：
          <b style="font-size:30px;">{{ info.balance | money }}</b>
          元
        </div>
        <el-button class="chargeBtn" @click="check('deposit')">充值</el-button>
      </div>
      <div class="hint" v-if="table.orderStatus == 0">
        当支付审核提交后，将由运营人员进行审核，审核通过后将通过银行进行支付。
      </div>
      <div class="hint" v-if="table.orderStatus == 0" style="color:#E90B0B">
        届时请保证账户内余额充足。
      </div>
      <div
        class="flexBox"
        style="justify-content:center;margin-top:24px;"
        v-if="table.orderStatus == 0 || table.orderStatus == 3"
      >
        <el-button
          type="primary"
          style="margin-right:220px;"
          @click="check('sendMsg')"
        >
          支付
        </el-button>
        <el-button
          style="border-radius:4px;border:2px solid rgba(25,137,250,1);color:#1989FA"
          @click="close"
        >
          返回
        </el-button>
      </div>
      <div
        class="flexBox"
        style="justify-content:center;margin-top:24px;"
        v-else
      >
        <el-button type="primary" @click="close">确认</el-button>
      </div>
    </el-dialog>
    <component :is="componentName"></component>
  </div>
</template>
<script>
import sendMsg from './child/otherSendMsg.vue';
import payHistory from './child/payHistory.vue';
import deposit from './deposit.vue';
import { bfAccount, loadAuthOrder } from '@/api/ajax';
import dateFormat from '@/tools/dateFormat';
export default {
  inject: ['itemData'],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    type: {
      default: 2
    }
  },
  data() {
    return {
      table: {
        orderStatus: 0
      },
      info: {},
      feiyongList: [
        { label: '合同签约费', key: 1 },
        { label: '实名认证费', key: 2 }
      ],
      showDetail: false,
      key: 'baofu',
      componentName: '',
      gysList: [
        {
          orderNo: '123124324235',
          companyName: '北京一样科技邮箱公司',
          time: '2019-08-27'
        },
        {
          orderNo: '123124321114235',
          companyName: '北京烧烤华盛顿科技邮箱公司',
          time: '2019-08-27'
        }
      ]
    };
  },
  methods: {
    close() {
      this.$parent.componentName = '';
    },
    check(componentName) {
      this.componentName = componentName;
    },
    transDt(v) {
      if (v) {
        return dateFormat(v);
      } else {
        return '';
      }
    }
  },
  components: {
    sendMsg,
    payHistory,
    deposit
  },
  filters: {
    transorderStatus(v) {
      let s = {
        0: '确认支付',
        1: '支付中',
        2: '支付成功',
        3: '支付失败'
      };
      return s[v];
    }
  },
  async created() {
    let {
      data: { data }
    } = await loadAuthOrder({ costOrderId: this.itemData.data.id });
    let data2 = await bfAccount();
    this.table = data;
    this.info = data2.data.data;
  }
};
</script>
<style lang="scss" scoped>
.hint {
  color: #bfbfbf;
  font-size: 12px;
  margin-bottom: 16px;
}
.accountType {
  width: 138px;
}
.chargeBtn {
  width: 92px;
  height: 36px;
  background: rgba(235, 142, 14, 1);
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  line-height: 36px;
  padding: 0;
}
.imgBox {
  img {
    width: 112px;
    height: 112px;
    margin-bottom: 20px;
  }
  .imgLabel {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .imgDes {
    color: #b4cfff;
    margin-bottom: 50px;
    font-size: 14px;
  }
}
.chartDia .flexBox {
  margin-bottom: 20px;
  justify-content: flex-start;
}
.leftBox {
  width: 50%;
  text-align: left;
}
.chartDia .borderBtm {
  padding-bottom: 20px;
  margin-bottom: 0;
  border-bottom: 1px solid #efefef;
}
</style>
